import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { starMasterProductConfig } from "@/lib/datasetRegistry"

// Thin config module — driven by `starMasterProductConfig`. The only page-specific
// JSX is the dual-sheet dropzone detail line (PRODUCT ACTIVE & INACTIVE), passed as
// the typed `dropzoneDetail` slot. Controller renders "admin/star_master_product/Uploads".
export default function AdminStarMasterProductUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return (
    <DatasetUploadsPage
      config={starMasterProductConfig}
      dropzoneDetail={
        <p className="mt-1 text-xs text-ink-muted">
          Sheet yang dibaca: <strong>PRODUCT (ACTIVE)</strong> &amp; <strong>PRODUCT (INACTIVE)</strong>
        </p>
      }
      {...props}
    />
  )
}
